module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/mag_image_temp-ed4d2259f7bed7bae25e10b61c236047.png";